
export enum EntityFormTabType {
    Sections = 'sections',
    Relation = 'relation',
    Custom = 'custom'
}